export const module = {
  info: {
    name: 'server',
    caption: 'server'
  },
  vuexModules: ['api', 'state'],
  mainRoute: '/cpanel',
  // noRoutes: true,
  sideMenu: {
    caption: 'server',
    icon: 'el-icon-cpu',
    routeName: 'module->server->create'
  }
}

export default module
